import { render } from "./TrafficQuote.vue?vue&type=template&id=8311d130&scoped=true"
const script = {}

import "./TrafficQuote.vue?vue&type=style&index=0&id=8311d130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8311d130"]])

export default __exports__